// extracted by mini-css-extract-plugin
export default {"processing-message-container":"g__processing-message-container--vatiF","processing-message-title":"g__processing-message-title--ldy_H"};